"use client";

import React, { useState } from "react";
import { Button } from "@oxpa/shared/ui/button";
import { RefreshCw, DownloadCloud } from "lucide-react";
import { enrichCompanyB2bData } from "../actions/enrichment";
import { useToast } from "@oxpa/shared/hooks/use-toast";

interface EnrichButtonProps {
  companyId: string;
  inn: string | null;
  className?: string;
}

export function EnrichButton({ companyId, inn, className }: EnrichButtonProps) {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleEnrich = async () => {
    if (!inn) {
      toast({
        title: "Ошибка",
        description: "ИНН компании не указан. Обогащение невозможно.",
        variant: "destructive",
      });
      return;
    }

    setIsLoading(true);
    
    try {
      const result = await enrichCompanyB2bData(companyId, inn);
      
      if (result.success) {
        toast({
          title: "Данные обновлены",
          description: "Рейтинги ЭКГ и НОПСС успешно синхронизированы.",
          variant: "default",
        });
      } else {
        toast({
          title: "Ошибка обогащения",
          description: result.error || "Не удалось получить официальные данные.",
          variant: "destructive",
        });
      }
    } catch (error) {
      toast({
        title: "Ошибка",
        description: "Произошла непредвиденная ошибка при запросе.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button 
      variant="outline" 
      size="sm" 
      onClick={handleEnrich} 
      disabled={isLoading || !inn}
      className={className}
    >
      {isLoading ? (
        <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
      ) : (
        <DownloadCloud className="w-4 h-4 mr-2" />
      )}
      {isLoading ? "Обновление..." : "Обновить из реестров"}
    </Button>
  );
}
